import React, { Component } from 'react';

function ContextMenu() {
  return (
    <ul className='context-menu hide'>
      <li>Delete conversation</li>
    </ul>
  );
}

export default ContextMenu;




// WEBPACK FOOTER //
// ./frontend/components/ContextMenu.js